import { EnhancedElement } from '@gebruederheitz/energize';
import { type ApiState, GameApi } from 'urban-challenger-sdk';

export class QrCodeDisplay extends EnhancedElement<
    HTMLElement,
    GameApi,
    ApiState
> {
    protected teamCode: string | null = null;

    protected onStateUpdate(state: ApiState): void {
        const newCode = state?.team?.code ?? null;
        console.log({
            oldCode: this.teamCode,
            newCode,
            visible: this.visible,
            isVisible: this.isVisible(),
        });
        if (this.teamCode !== newCode) {
            if (!newCode) {
                this.hide();
                this.teamCode = null;
            } else {
                this.teamCode = newCode;
                this.find('uc-qr-code').setAttribute('text', this.teamCode);
                if (!this.visible) {
                    this.show();
                }
            }
        }
    }
}
